export const PauseIcon = ({ width = 10, height = 10, color = 'white', ...props }: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g opacity='0.6'>
      <rect x='1' y='2' width='6' height='6' rx='1' fill={color} />
    </g>
  </svg>
);
